import { EDITOR_COMPACT_WIDTH, MOBILE_WIDTH } from '../constants/SizeConstants';

export const isMobileDevice = () =>
  process.env.NODE_ENV === 'test' ? false : window.screen.availWidth <= MOBILE_WIDTH;

export const isEditorCompactMode = () =>
  process.env.NODE_ENV === 'test' ? false : window.innerWidth <= EDITOR_COMPACT_WIDTH;
